<div class="contact-us-wrapper">
  <div class="contact-us-wrapper__router">
    <div class="contact-us-wrapper__container">
      <div class="contact-us-wrapper__content">
        <ng-container *ngIf="banner.message">
          <app-message-banner
            [header]="banner.header"
            [text]="banner.message"
            [style]="banner.style"
            [icon]="banner.icon"
          ></app-message-banner>
        </ng-container>
        <app-contact-us-form></app-contact-us-form>
      </div>
    </div>
  </div>
  <div
    class="contact-us-wrapper__container contact-us-wrapper__container--background"
  ></div>
</div>
